// Footer component 
import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <p>&copy; {currentYear} Trade Relations Atlas</p>
        <Link to="/status" className="footer-status-link">System status</Link>
      </div>
    </footer>
  );
}

export default Footer;
